import "@babel/polyfill";
import "whatwg-fetch";
import "~/styles/main.scss";
import "~/scripts/lib/autotrack";
import React from "react";
import { render } from "react-dom";
import App from "~/scripts/components/App";

render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/scripts/main.js